import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import Dashboard from "@/pages/Dashboard";
import CreateWedding from "@/pages/CreateWedding";
import WeddingAdmin from "@/pages/WeddingAdmin";
import WeddingGuest from "@/pages/WeddingGuest";
import GuestUpload from "@/pages/GuestUpload";
import GuestGallery from "@/pages/GuestGallery";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-center" richColors />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Auth mode="login" />} />
            <Route path="/signup" element={<Auth mode="signup" />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/dashboard/new" element={<CreateWedding />} />
            <Route path="/dashboard/w/:id" element={<WeddingAdmin />} />
            <Route path="/w/:slug" element={<WeddingGuest />} />
            <Route path="/w/:slug/upload" element={<GuestUpload />} />
            <Route path="/w/:slug/memories" element={<GuestGallery />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
